import React from "react";
import { Button } from "../../ButtonElement";

import {
  InfoContainer,
  InfoWrapper,
  InfoRow,
  Column1,
  Column2,
  TextWrapper,
  TopLine,
  Heading,
  Heading3,
  Subtitle,
  BtnWrap,
  Img,
  ImgWrap,
} from "./TalksSectionElements";

const TalksSection = ({
  lightBg,
  id,
  imgStart,
  topLine,
  lightText,
  headline1,
  headline2,
  headline3,
  darkText,
  description1b,
  description1,
  description2,
  description3,
  description4,
  description5,
  description6,
  buttonLabel,
  image,
  backgroundImage,
  showButton,
  buttonToPDF,
  buttonLink,
  alt,
  primary,
  dark,
  dark2,
}) => {
    const handleButtonClick = (e) => {
      if (buttonToPDF) {
        e.preventDefault();
        window.open(buttonLink, '_blank', 'noopener,noreferrer');
      }
    };

  return (
    <>
      <InfoContainer backgroundImage={backgroundImage} lightBg={lightBg} id={id}>
        <InfoWrapper>
          <InfoRow imgStart={imgStart}>
            <Column1>
              <TextWrapper>
                <TopLine>{topLine}</TopLine>
                <Heading lightText={lightText}>{headline1}</Heading>
                <Heading lightText={lightText}>{headline2}</Heading>
                <Heading lightText={lightText}>{headline3}</Heading>
                <Heading3 darkText={darkText}>{description1b}</Heading3>
                <Subtitle darkText={darkText}>{description1}</Subtitle>
                <Subtitle darkText={darkText}>{description2}</Subtitle>
                <Subtitle darkText={darkText}>{description3}</Subtitle>
                <Subtitle darkText={darkText}>{description4}</Subtitle>
                <Subtitle darkText={darkText}>{description5}</Subtitle>
                <Subtitle darkText={darkText}>{description6}</Subtitle>
                {showButton && <BtnWrap>
                  <Button
                    to={buttonLink}
                    smooth="true"
                    duration={500}
                    spy="true"
                    exact="true"
                    offset={-80}
                    primary={primary ? 1 : 0}
                    dark={dark ? 1 : 0}
                    dark2={dark2 ? 1 : 0}
                    onClick={handleButtonClick}
                  >
                    {buttonLabel}
                  </Button>
                </BtnWrap>}
              </TextWrapper>
            </Column1>
            <Column2>
              <ImgWrap>
              <Img src={image} alt={alt} />
              </ImgWrap>
            </Column2>
          </InfoRow>
        </InfoWrapper>
      </InfoContainer>
    </>
  );
};

export default TalksSection;
